// extracted by mini-css-extract-plugin
export var button = "Button-module--button--8f7e8";
export var button__darkBlue = "Button-module--button__darkBlue--36c3d";
export var button__edgesGrey = "Button-module--button__edgesGrey--a0984";
export var button__edgesRed = "Button-module--button__edgesRed--10732";
export var button__loader = "Button-module--button__loader--093cf";
export var button__red = "Button-module--button__red--54792";
export var button__transparent = "Button-module--button__transparent--6b7c0";
export var loadingSpinner = "Button-module--loadingSpinner--1ebee";